import { Chip } from "@heroui/react";

import { Product } from "@/types";

const aed = (value: number | null | undefined) =>
  value == null ? "-" : `AED ${value.toFixed(2)}`;

/** The selling price, with the market, original and supplier offer prices in quiet lines below. */
export function PriceCell({ product }: { product: Product }) {
  return (
    <div className="flex flex-col gap-0.5 leading-tight whitespace-nowrap tabular-nums">
      <div className="flex items-center gap-2">
        <span className="text-sm font-semibold">{aed(product.price)}</span>
        {product.priceOverride ? (
          <Chip color="accent" size="sm" variant="soft">
            Manual
          </Chip>
        ) : null}
      </div>
      <span className="text-muted text-xs">
        {product.marketPrice != null
          ? `Market ${aed(product.marketPrice)} · `
          : ""}
        Original {aed(product.originalPrice)}
      </span>
      {product.supplierOfferPrice != null ? (
        <span className="text-xs text-(--warning)">
          Offer {aed(product.supplierOfferPrice)}
        </span>
      ) : null}
    </div>
  );
}
